export const urlBase64ToUint8Array = (base64String) => {
  var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const loadVersionBrowser = () => {
  var ua = window.navigator.userAgent,
    tem,
    M =
      ua.match(
        /(opera|chrome|safari|firefox|Edg|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: 'IE', version: tem[1] || '' };
  }
  if (M[1] === 'Chrome') {
    const temOpr = ua.match(/\bOPR\/(\d+)/);
    if (temOpr !== null) {
      return { name: 'Opera', version: temOpr[1] };
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return {
    name: M[0],
    version: M[1],
  };
};

export function removeSignature(text) {
  return text.replace(/-Signature-[\s\S]*/g, '');
}

export const readFile = (file) => {
  return new Promise((resolve, reject) => {
    try {
      var reader = new FileReader();

      reader.onload = (e) => resolve(e.currentTarget.result);
      reader.onabort = (e) => reject(e);
      reader.onerror = (e) => reject(e);

      reader.readAsDataURL(file);
    } catch (error) {
      reject(error);
    }
  });
};

export const downloadPdf = (blob, filename) => {
  const newBlob = new Blob([blob], { type: 'application/pdf' });
  const data = window.URL.createObjectURL(newBlob);
  const link = document.createElement('a');

  link.href = data;
  link.download = `${filename}.pdf`;
  link.click();
};

export const isEmail = (email) => {
  return /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/i.test(email);
};

export const addLeadingZeros = (value) =>
  value.startsWith('00') ? value : `00${value}`;

export const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  const lowerCaseString = s.toLowerCase();
  return lowerCaseString.charAt(0).toUpperCase() + lowerCaseString.slice(1);
};
